import mockResponses from "./mockResponses";

const useMockData = false;

// 🚨🚨🚨 👇 Don't change this 👇 🚨🚨🚨
const _useMockData_PROTECTED =
  process.env.NODE_ENV === "development" ? useMockData : false;
// 🚨🚨🚨 👆 Don't change this 👆 🚨🚨🚨

export const mockData = {
  shouldMock: _useMockData_PROTECTED,
  ...mockResponses,
};
